export const sum = (rows: number[]) => {
  const expr = rows.map(row => `@${row}`).join('+');
  return `=${expr}`;
};
